import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IBranding } from '../interfaces/branding';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private rootUrl: string = "/api/configuration";

  constructor(private httpClient: HttpClient) { }

  public getBranding(): Observable<IBranding> {
    var url = this.rootUrl + "/branding";
    return this.httpClient.get<IBranding>(url);
  }
}
